import { connect } from 'react-redux'
import {
  doFetchDraftOrders,
  doDraftOrderCreate,
  doDraftOrderUpdate,
} from 'ducks/integrations/shopify'
import selectCurrentConversationId from 'ducks/searches/selectors/selectCurrentConversationId'
import { debounce } from 'util/functions'
import ShopifyNewOrder from './view'

const select = state => {
  return {
    currentConversationId: selectCurrentConversationId(state),
  }
}

const perform = () => {
  return dispatch => ({
    fetchDraftOrders: (integration, customerGid) =>
      dispatch(doFetchDraftOrders(integration.id, customerGid, 1)),
    draftOrderCreate: (integration, customerGid, lineItems) =>
      dispatch(doDraftOrderCreate(integration.id, customerGid, lineItems)),
    draftOrderUpdate: debounce((integration, draftOrderId, input, callback) => {
      return dispatch(
        doDraftOrderUpdate(integration.id, draftOrderId, input)
      ).then(callback)
    }, 500),
  })
}

export default connect(select, perform)(ShopifyNewOrder)
